<nav id="site-specific-nav" aria-label="site-specific navigation">
  <ul>
    @for (item of navItems; track item) {
      <li>
        @if (!item.children) {
          <a [routerLink]="item.link">{{ item.label }}</a>
        } @else {
          <a>{{ item.label }}</a>
          <ul>
            @for (child of item.children; track child) {
              <li><a [routerLink]="child.link">{{ child.label }}</a></li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</nav>

